"use client";

import { useReducedMotion } from "framer-motion";
import { Reveal } from "../../home/motion";
import { Section, SectionHeading } from "../../home/section";
// Reuse the real product scene from the homepage use-case showcase. It is the
// sharpest multi-location wedge: a live network rollup that watches every
// location and surfaces the one that starts to slip. Rendered standalone here
// (no tab strip): plays once on scroll-in, then freezes (no onComplete).
import { GrowLocations } from "../../home/use-case-tabs/scenes/grow-locations";

export function MultiLocationSpotlight() {
	const reduce = useReducedMotion() ?? false;

	return (
		<Section
			id="visibility"
			className="border-t border-border bg-background"
			width="6xl"
		>
			<SectionHeading
				align="left"
				size="sm"
				eyebrow="Performance visibility"
				title={
					<>
						See every location in one place.
						<span className="text-muted-foreground">
							{" "}
							Helios watches the whole network in real time and flags the
							location that starts to slip, before it costs you a quarter.
						</span>
					</>
				}
			/>

			<Reveal className="mt-10 lg:mt-14">
				<div className="overflow-hidden rounded-2xl border border-border bg-card shadow-xl lg:h-[36rem]">
					<GrowLocations reduce={reduce} />
				</div>
			</Reveal>
		</Section>
	);
}
